module.exports = __webpack_public_path__ + "img/007-octopus.ca572587.svg";